import { ValidationError } from "sequelize"
import {
    QidCompany,
    QidCompanyCreate,
    QidCompanySave,
    QidCompanyChangeStatus,
} from "server/models"
import { PUBLISHED, UNPUBLISHED } from "const"
import { OrderType, PublishedUnpublished } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    QidCompanyList,
    QidCompanyFilters,
    QidCompanyValidation,
} from "./types"

export const LoadAllQidCompanies = (onlyActive = false) => (
    GET("/qidCompany/all")
    .then((companies: QidCompany[]) => {
        const companyList: QidCompanyList = {}
        companies.forEach((company) => {
            if (onlyActive && company.status === UNPUBLISHED) return
            companyList[company.id] = company
        })
        return companyList
    })
)

export const LoadQidCompanyById = (companyId: number) => (
    GET(`/qidCompany/id/${companyId}`)
    .then((company: QidCompany) => company)
)

export const SaveQidCompany = (
    id: number,
    company: QidCompanyCreate,
    lang: LangType,
) => {
    const data: QidCompanySave = {
        id,
        company,
    }
    return POST(
        "/qidCompany/save",
        JSON.stringify(data),
    ).then((res) => {
        const newCompany = res as QidCompany
        const error = res as ValidationError

        return {
            newCompanyId: newCompany.id || null,
            validation: <QidCompanyValidation>validate(error, lang),
        }
    })
}

export const ChangeQidCompanyStatus = (company: QidCompany) => {
    const status: PublishedUnpublished = company.status === PUBLISHED ? UNPUBLISHED : PUBLISHED
    const data: QidCompanyChangeStatus = {
        id: company.id,
        status,
    }
    return POST(
        "/qidCompany/changeStatus",
        JSON.stringify(data),
    ).then((updatedRows: [number]) => (
        updatedRows && updatedRows.length && updatedRows[0] === 1
            ? status
            : company.status
    ))
}

export const DeleteQidCompany = (companyId: number) => (
    DELETE(`/qidCompany/delete/${companyId}`)
    .then((removedRows: number) => removedRows)
)


export const SortQidCompanies = (
    companies: QidCompany[],
    sortColumn: keyof QidCompany,
    sortOrder: OrderType,
    filters: QidCompanyFilters,
): number[] => {
    const companiesFiltered = companies.filter((company) => {
        let showRow = true
        if (filters.status && company.status !== filters.status) showRow = false
        else if (filters.search) showRow = search(filters.search, company)
        return showRow
    })
    companiesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const companyIds: number[] = []
    companiesFiltered.forEach((company) => companyIds.push(company.id))

    return companyIds
}
